if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pflm_surveyanonymous","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(19|237|25|386|934)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}